const ROADIE_BACKSTAGE_PULL_REQUESTS_DEFAULT_FILTER_ANNOTATION = "roadie-backstage-pull-requests/default-filter";
const isRoadieBackstageDefaultFilterSet = (entity) => {
  return entity?.metadata.annotations?.[ROADIE_BACKSTAGE_PULL_REQUESTS_DEFAULT_FILTER_ANNOTATION] ?? "";
};

export { ROADIE_BACKSTAGE_PULL_REQUESTS_DEFAULT_FILTER_ANNOTATION, isRoadieBackstageDefaultFilterSet };
//# sourceMappingURL=isRoadieBackstageDefaultFilterSet.esm.js.map
